import { CartLinesUpdateEvent } from '@shopify/events';

const palette = {'Elegant Gray':'#77756f','Silver Gray':'#bebbb4','Pine Green':'#65734f','Mocha':'#8c7362','Amber':'#b88a48'};
const colourOrder = Object.keys(palette);
const dimensions = s => String(s).match(/^(70|90|110)[x×](\d+)\s*cm$/i);
const formatSize = s => String(s).replace(/\s*cm$/i,'').replace(/[x×]/,' × ') + ' cm';
for (const root of document.querySelectorAll('[data-cv-product]')) {
  if (root.dataset.ready) continue;
  root.dataset.ready = 'true';
  const data = JSON.parse(root.querySelector('[data-cv-data]').textContent);
  const q = s => root.querySelector(s);
  const options = data.options.map(o => ({...o, values:o.values.map(v => typeof v === 'string' ? v : v.name)}));
  const ci = options.findIndex(o => ['kleur','color','colour'].includes(o.name.toLowerCase()));
  const si = options.findIndex(o => ['maat','size'].includes(o.name.toLowerCase()));
  if (ci < 0 || si < 0) continue;
  // Presentation only: never mutate the underlying variant/options records.
  const variants = data.variants.filter(v => colourOrder.includes(v.options[ci]) && dimensions(v.options[si]));
  const colours = colourOrder.filter(c => variants.some(v => v.options[ci] === c));
  const sizes = options[si].values.filter(s => dimensions(s) && variants.some(v => v.options[si] === s));
  const form = q('[data-cv-form]'), guide = q('[data-cv-guide]');
  const key = 'cendriva-choice-' + data.productId;
  let saved = {};
  try { saved = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch {}
  const params = new URL(location.href).searchParams;
  const urlId = params.get('variant');
  const urlColour = params.get('kleur')?.replace('Mocha pillowcase','Mocha');
  const explicitColour = colours.includes(urlColour);
  const requested = data.variants.find(v => v.id === urlId);
  const initial = variants.find(v => v.id === urlId) || (!explicitColour && !requested ? variants.find(v => v.id === data.selectedId) : null);
  let colour = initial?.options[ci] || (explicitColour ? urlColour : requested ? requested.options[ci].replace('Mocha pillowcase','Mocha') : colours.includes(saved.colour) ? saved.colour : colours[0]);
  if (!colours.includes(colour)) colour = colours[0];
  let size = initial?.options[si] || (!explicitColour && !requested && sizes.includes(saved.size) ? saved.size : null);
  let variant, busy = false, shownColour;
  const money = cents => new Intl.NumberFormat('nl-NL',{style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(cents/100);
  const priceNodes = root.querySelectorAll('[data-cv-price],[data-cv-sticky-price]');
  const error = message => {q('[data-cv-error]').textContent = message; q('[data-cv-error]').hidden = !message;};
  const main = q('[data-cv-main]');
  main.addEventListener('error',()=>{main.hidden=true;q('[data-cv-missing]').hidden=false;q('[data-cv-missing] p').textContent='De foto kon niet worden geladen. Kies een andere productfoto of neem contact met ons op.';});
  main.addEventListener('load',()=>{main.hidden=false;q('[data-cv-missing]').hidden=true;});
  function showImage(image) {
    if (!image) return;
    main.hidden=false;q('[data-cv-missing]').hidden=true;
    main.alt=image.label;main.src=image.src;
    q('[data-cv-gallery-label]').textContent=image.label;
    for(const b of root.querySelectorAll('[data-photo]')) b.setAttribute('aria-pressed',String(b.dataset.photo===image.src));
  }
  function updateGallery() {
    if(shownColour===colour)return;
    shownColour=colour;
    const images=[...new Set(variants.filter(v=>v.options[ci]===colour && v.image).map(v=>v.image))].map(src=>({src,label:colour+' · productbeeld'}));
    const general=(data.gallery||[]).filter(im=>im.cover && !im.colours.length).map(im=>({src:im.src,label:'Algemeen productbeeld · collectie en details'}));
    q('[data-cv-image-chip]').style.setProperty('--swatch',palette[colour]);
    q('[data-cv-image-colour]').textContent=colour;
    q('[data-cv-thumbs]').replaceChildren(...[...images,...general].map((image,i)=>{
      const b=document.createElement('button');b.type='button';b.dataset.photo=image.src;b.title=image.label;b.setAttribute('aria-label',image.label+' '+(i+1));
      const im=document.createElement('img');im.src=image.src;im.alt='';im.width=76;im.height=76;im.loading='lazy';b.append(im);b.onclick=()=>showImage(image);return b;
    }));
    if(images.length)showImage(images[0]);else{main.hidden=true;q('[data-cv-missing]').hidden=false;}
  }
  function update() {
    variant = size ? variants.find(v => v.options[ci] === colour && v.options[si] === size) : null;
    q('[data-cv-colour-label]').textContent = colour;
    q('[data-cv-size-label]').textContent = size ? formatSize(size) : 'Kies een maat';
    for (const button of root.querySelectorAll('[data-colour]')) button.setAttribute('aria-pressed', String(button.dataset.colour === colour));
    for (const button of root.querySelectorAll('[data-size]')) {
      const match = variants.find(v => v.options[ci] === colour && v.options[si] === button.dataset.size);
      button.disabled = busy || !match || (!data.review && !match.available);
      button.setAttribute('aria-pressed', String(button.dataset.size === size));
      button.title = !match || (!data.review && !match.available) ? 'Niet beschikbaar' : button.dataset.size;
    }
    const prices = variants.filter(v => v.options[ci] === colour).map(v => v.price);
    priceNodes.forEach(node => node.textContent = variant ? money(variant.price) : 'Vanaf ' + money(Math.min(...prices)));
    const input = q('[data-cv-variant]'); input.value = variant?.id || ''; input.disabled = !variant || data.review;
    const qty = form.elements.quantity;
    qty.min = variant?.min || 1; qty.step = variant?.increment || 1;
    if (variant?.max) qty.max = variant.max; else qty.removeAttribute('max');
    if (+qty.value < +qty.min) qty.value = qty.min;
    q('[data-cv-add]').disabled = busy || !variant || !variant.available || data.review;
    q('[data-cv-add]').textContent = busy ? 'Toevoegen…' : 'In winkelwagen';
    q('[data-cv-sticky-add]').disabled = busy || (!!size && (!variant || !variant.available || data.review));
    q('[data-cv-sticky-add]').textContent = busy ? 'Toevoegen…' : size ? 'In winkelwagen' : 'Kies je maat';
    q('[data-cv-sticky-selection]').textContent = size ? colour + ' · ' + formatSize(size) + ' (1 los deel)' : 'Kies jouw maat per bankdeel';
    q('[data-cv-summary]').textContent = size ? colour + ' · ' + formatSize(size) + ' · één los deel' : 'Eén beschermer per gekozen maat. Geen complete bankset.';
    q('[data-cv-availability]').textContent = data.review ? 'Niet bestelbaar in deze conceptweergave.' : !variant ? 'Kies een maat om de beschikbaarheid te bekijken.' : variant.available ? 'Je gekozen uitvoering is bestelbaar.' : 'Deze uitvoering is momenteel niet beschikbaar.';
    updateGallery();
    for(const b of root.querySelectorAll('[data-colour]')) b.disabled=busy;
    try {sessionStorage.setItem(key,JSON.stringify({colour,size}));} catch {}
    const url = new URL(location.href);
    if (url.searchParams.has('kleur')) url.searchParams.set('kleur',colour);
    if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant');
    history.replaceState(null,'',url);
    error('');
  }
  for (const name of colours) {
    const b = document.createElement('button'); b.type = 'button'; b.className = 'cv-swatch'; b.dataset.colour = name; b.setAttribute('aria-label',name); b.title = name;
    const chip = document.createElement('i'); chip.style.setProperty('--swatch',palette[name] || palette[name.replace(/ pillowcase$/, '')]); b.append(chip); b.onclick = () => {colour = name;if(size && !variants.some(v=>v.options[ci]===colour && v.options[si]===size && v.available))size=null;update();}; q('[data-cv-colours]').append(b);
  }
  for (const width of [70,90,110]) {
    const group=document.createElement('div');group.className='cv-size-group';
    const heading=document.createElement('p');heading.textContent='Breedte '+width+' cm';
    const list=document.createElement('div');list.className='cv-sizes';group.append(heading,list);
    for(const name of sizes.filter(s=>+dimensions(s)[1]===width).sort((a,b)=>+dimensions(a)[2]-+dimensions(b)[2])) {
      const b=document.createElement('button');b.type='button';b.className='cv-size';b.dataset.size=name;b.textContent=formatSize(name);b.setAttribute('aria-label',formatSize(name));
      b.onclick=()=>{size=name;update();};list.append(b);
    }
    if(list.children.length)q('[data-cv-sizes]').append(group);
  }
  const openGuide = () => { if (!guide.open) guide.showModal(); };
  root.querySelectorAll('[data-cv-guide-open]').forEach(b => b.onclick = openGuide);
  q('[data-cv-guide-close]').onclick = () => guide.close();
  guide.addEventListener('click',e => { if (e.target === guide) {const r=guide.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) guide.close();} });
  q('[data-cv-sticky-add]').onclick = () => {if (!size) q('[data-cv-sizes]').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'}); else form.requestSubmit();};
  const stickyBar = q('.cv-sticky-buy');
  const mainAddBtn = q('[data-cv-add]');
  if (stickyBar && mainAddBtn && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          stickyBar.classList.add('cv-sticky-buy--hidden');
        } else {
          const rect = entry.boundingClientRect;
          if (rect.top < 0) {
            stickyBar.classList.remove('cv-sticky-buy--hidden');
          } else {
            stickyBar.classList.add('cv-sticky-buy--hidden');
          }
        }
      }
    }, { threshold: 0.1 });
    stickyObserver.observe(mainAddBtn);
  }
  form.addEventListener('submit',async e => {
    e.preventDefault();
    const selected = variants.find(v=>v.options[ci]===colour && v.options[si]===size);
    if (!selected || !selected.available || data.review || busy || !form.reportValidity()) return;
    const quantity = +form.elements.quantity.value;
    busy = true; update();
    const deferred = CartLinesUpdateEvent.createPromise();
    root.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:selected.id,quantity}],promise:deferred.promise}));
    try {
      const body = new FormData(form);
      const ids = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(n=>n.dataset.sectionId))];
      body.set('id',selected.id); body.set('quantity',String(quantity));
      if(ids.length) body.set('sections',ids.join(',')); body.set('sections_url',location.pathname);
      const response = await fetch(Theme.routes.cart_add_url,{method:'POST',body,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Toevoegen is niet gelukt. Probeer opnieuw.');
      const cartResponse = await fetch(Theme.routes.cart_url + '.js');
      if (!cartResponse.ok) throw new Error('Je bestelling kon niet opnieuw worden ingelezen. Controleer je winkelwagen.');
      const cart = await cartResponse.json();
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:root.id || 'cendriva-product',itemCount:quantity,productId:data.productId,sections:result.sections,didError:false}});
      document.querySelectorAll('[data-cv-count]').forEach(n=>n.textContent=cart.item_count || '');
      document.querySelector('theme-drawer#cart-drawer')?.open();
    } catch (err) {
      deferred.reject(err); error(err.message || 'Toevoegen is niet gelukt. Probeer opnieuw.');
    } finally {busy=false; const message=q('[data-cv-error]').textContent; update(); if(message) error(message);}
  });
  // Fudge debug controls — preview-only, no-ops live. See .skills/storefront/debug-ui.md
  window.__fudgeDebug?.action('Open de maathulp',openGuide);
  window.__fudgeDebug?.action('Sluit de maathulp',()=>guide.close());
  window.__fudgeDebug?.command('Kies productopties',(c,s)=>{if(!colours.includes(c)||!sizes.includes(s))return null;colour=c;size=s;update();return variant;});
  update();
}
